import React, { useState, useEffect } from 'react'
import Paper_negative from '../images/Paper Negative.svg'
import Paper_plus from '../images/Paper Plus.svg'
import arrow from '../images/arrow.png'
import { server_API, server_django_api } from '../config'
import axios from 'axios'
import { TailSpin } from "react-loader-spinner"
import { useLocation, useNavigate } from 'react-router-dom'
import ReactCountryFlag from "react-country-flag"
import { useSelector } from 'react-redux';
import { selectCid } from '../features/companyid';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import axiosInstance from '../axiosInstance'
import { getPhoneCode } from "../utils/currencyUtils";

const NewCandidate = (props) => {

  const location = useLocation()

  const jid = location.state.id
  const cid = useSelector(selectCid)

  const [rem1, setRem1] = useState(0);
  const [rem2, setRem2] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0)

    console.log(jid)

    axiosInstance.get(`/v2/job/get/${jid}/${cid}`)
      .then((res) => {
        console.log(res)
        console.log(res.data.normaltext)
        setJd(res.data.normaltext)
        setRem1(res.data.firstreminder);
        setRem2(res.data.finalreminder);
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const [admin, setAdmin] = useState(false)
  const [fname, setFname] = useState('')
  const [email, setEmail] = useState('')
  const [pnum, setPnum] = useState('')
  const [add1, setAdd1] = useState('')
  const [add2, setAdd2] = useState('')
  const [emptyRes, setEmptyRes] = useState(false)
  const [buttonLoader, setButtonLoader] = useState(false)
  const [loader, setLoader] = useState(null)
  const [popup, setPopup] = useState(false)
  const [pin, setPin] = useState('')
  const [city, setCity] = useState('')
  const [state, setState] = useState('')
  const [country, setCountry] = useState('')
  const [highestQualification, setHighestQualification] = useState('')
  const [job, setJob] = useState('')
  const [company, setCompany] = useState('')
  const [currentSalary, setCurrentSalary] = useState('')
  const [expectedSalary, setExpectedSalary] = useState('')
  const [addInfo, setAddInfo] = useState('')
  const [skill, setSkill] = useState('')
  const [editor, setEditor] = useState(false)
  const [viewer, setViewer] = useState(false)
  const [tab, setTab] = useState(0)
  const [experience, setExperience] = useState('')
  const [coverletter, setCoverLetter] = useState(null)
  const [resume, setResume] = useState(null)
  const [jd, setJd] = useState('')
  const [d1, setD1] = useState('')
  const [d2, setD2] = useState('')
  const [err, setErr] = useState(true)
  const [companyCountryCode, setCompanyCountryCode] = useState("IN");
  const countryCode = getPhoneCode(companyCountryCode);
  const [skillset, setskillset] = useState([])
  const [ws, setWs] = useState('')
  const [source, setSource] = useState('')
  const [educationDetails, setEducationDetails] = useState([{
    "insName": "",
    "courseName": "",
    "stDate": "",
    "endDate": "",
    "score": ""
  }])
  const [fnameError, setFnameError] = useState(false)
  const [pnumError, setPnumError] = useState(false)
  const [emailError, setEmailError] = useState(false)
  const [extraDetails, setExtraDetails] = useState({});
  const hasCountryCode = pnum.includes(countryCode);
  const invalidLength = pnum.length > 0 && pnum.length !== 10;
  const startsWithZero = pnum.startsWith("0") && pnum.length > 0;
  const [isValidEmail, setIsValidEmail] = useState(true);
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  useEffect(() => {
    if (admin) {
      setWs('On-Site')
    }
    else if (editor) {
      setWs('Hybrid')
    }
    else if (viewer) {
      setWs('Remote')
    }
  }, [admin, editor, viewer])

  const addNew = () => {
    setEducationDetails([...educationDetails, {
      "insName": "",
      "courseName": "",
      "stDate": "",
      "endDate": "",
      "score": ""
    }])
  }

  const handleChange = (index, e) => {
    e.preventDefault()
    const newData = educationDetails.map((f, i) => {
      if (index === i) {
        return { ...f, [e.target.name]: e.target.value }
      }
      return f
    })
    setEducationDetails(newData)
  }

  useEffect(() => {
    if (cid) {
      axiosInstance
        .get(`/v2/company/get/${cid}`)
        .then((response) => {
          console.log("Company API Response:", response.data);

          if (response.data.company_countries && response.data.company_countries.length > 0) {
            const code = response.data.company_countries[0];
            setCompanyCountryCode(code);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (pin.length == 6) {
      axios.get(`https://api.postalpincode.in/pincode/${pin}`)
        .then((response) => {
          console.log(response)
          setCity(response.data[0].PostOffice[0].Division)
          setState(response.data[0].PostOffice[0].Circle)
          setCountry(response.data[0].PostOffice[0].Country)
        })
        .catch((error) => {
          alert('Something went wrong! Please try again')
          console.log(error)
        })
    }
  }, [pin, cid])

  const options = [
    { value: 'Campus campaign', label: 'Campus campaign' },
    { value: 'Company website', label: 'Company website' },
    { value: 'Employees referral', label: 'Employees referral' },
    { value: 'Naukri', label: 'Naukri' },
    { value: 'Indeed', label: 'Indeed' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Recruitment agency', label: 'Recruitment agency' },
    { value: 'Others', label: 'Others' }
  ];



  const resSave = () => {
    setLoader(true)

    const data = new FormData()
    data.append('name', fname)
    data.append('companyid', cid)
    data.append('totalexperience', experience)
    data.append('jobid', jid)
    data.append('highestqualification', highestQualification)
    data.append('currentJobtitle', job)
    data.append('department', job.department)
    data.append('currentcomany', company)
    data.append('currentsalary', currentSalary)
    data.append('expectedsalary', expectedSalary)
    data.append('skillset', skillset.toString())
    data.append('additionalinfo', addInfo)
    data.append('address', `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`)
    data.append('email', email)
    data.append('educationaldetails', educationDetails)
    data.append('applieddate', "")
    data.append('phone', pnum)
    data.append('jd', jd)
    data.append('file', resume)
    data.append('aiscore', 0)
    data.append('voiceanalysisscore', 0)
    data.append('firstreminder', d1)
    data.append('finalreminder', d2)
    data.append('countrycode', countryCode)
    data.append('twelvehrwhatsappreminder', '')
    data.append('onehrwhatsappreminder', '')
    data.append('interviewdate', '')
    data.append('interviewtime', '')
    data.append('heardaboutus', source)
    data.append("addApplicant", 1);
    axiosInstance.post(`/v2/applicant/createnew`, data)
      .then((res) => {

        setLoader(false)
        toast.success("Application Submitted Successfully")
        setErr(false)
        setPopup(true)
      })
      .catch((err) => {
        alert('This email is already registered, please enter a new email id')
        setLoader(false)
        setPopup(false)
        console.log(err)
      })

  }


  const summary = () => {
    setButtonLoader(true)
    setEmptyRes(false)
    var formdata = new FormData();
    formdata.append("file", resume);
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
    fetch(`${server_API}/v2/applicant/resume/summary`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setButtonLoader(false)
        if (!result.success.Name.includes("Not Provided")) {
          setFname(result.success.Name);
        }
        else {
          setFnameError(true)
        }
        if (!result.success.Email.includes("Not Provided")) {
          setEmail(result.success.Email);
        }
        else {
          setEmailError(true)
        }
        if (!result.success["Phone Number"].includes("Not Provided")) {
          var phone = result.success["Phone Number"];
          phone = phone.replaceAll("-", "");
          phone = phone.replaceAll(countryCode, "");
          if (phone.startsWith("0")) {
            phone = phone.substring(1);
          }
          setPnum(phone);
        }
        else {
          setPnumError(true)
        }
        if (!result.success["Total Experience"].includes("Not Provided")) {
          setExperience(result.success["Total Experience"]);
        }
        if (!result.success.Skills.includes("Not Provided")) {
          setskillset(result.success.Skills);
        }
        if (!result.success["Highest Qualification"].includes("Not Provided")) {
          setHighestQualification(result.success["Highest Qualification"]);
        }
      })
      .catch(error => console.log('error', error));
  }

  const inputNum = (event) => {
    const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, '');

      // Format the number with commas
      const formattedValue = Number(sanitizedValue).toLocaleString();

      setCurrentSalary(formattedValue);
    }
    else {
      setCurrentSalary('')
    }
  };


  const onlyContainsNumbers = (str) => /^[0-9,.]*$/.test(str);

  const inputExpectedSalary = (event) => {
    const { value } = event.target;
    // Remove any existing commas from the input
    if (onlyContainsNumbers(value)) {
      const sanitizedValue = value.replace(/,/g, '');

      // Format the number with commas
      const formattedValue = Number(sanitizedValue).toLocaleString();

      setExpectedSalary(formattedValue);
    }
    else {
      setExpectedSalary('')
    }
  }
  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  const todayDate = new Date();
  useEffect(() => {
    if (rem1 > 0 && rem2 > 0) {
      const reminderDate1 = new Date(
        parseInt(todayDate.getTime()) + parseInt(rem1)
      );
      console.log(reminderDate1.toLocaleDateString());
      setD1(
        `${reminderDate1.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[0],
          2
        )}-${padWithLeadingZeros(
          reminderDate1.toLocaleDateString().split("/")[1],
          2
        )}`
      );

      const reminderDate2 = new Date(parseInt(rem2) + reminderDate1.getTime());
      //
      setD2(
        `${reminderDate2.toLocaleDateString().split("/")[2]
        }-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[0],
          2
        )}-${padWithLeadingZeros(
          reminderDate2.toLocaleDateString().split("/")[1],
          2
        )}`
      );
    }
  }, [rem1, rem2]);


  const addNewApplicant = () => {
    const data = new FormData()
    data.append('resume', resume)
    data.append('jd', jd)
    fetch(`${server_django_api}/similarity_index`, { method: 'POST', body: data })
      .then(response => response.json())
      .then(data => {
        console.log(data.status)
        axiosInstance.post(`/v2/applicant/create`, {
          "name": fname,
          "companyid": cid,
          "jobid": jid,
          "totalexperience": experience,
          "qualification": highestQualification,
          "currentJobtitle": job,
          "currentcomany": company,
          "currentsalary": currentSalary,
          "expectedsalary": expectedSalary,
          "skillset": skill,
          "additionalinfo": addInfo,
          "address": `${add1}, ${add2}, ${pin}, ${city}, ${state}, ${country}`,
          "email": email,
          "educationaldetails": educationDetails,
          "applieddate": "",
          "phone": pnum,
          "addedby": "",
          "coverletter": "",
          "resume": "",
          "aiscore": 0,
          "voiceanalysisscore": 0,
          "resumescore": parseInt(data.status)
        })
          .then((res) => {
            console.log(res)
            setFname('')
            setPnum('')
            setEmail('')
            setResume(null)
            // axios.put(`${server_API}/v1/job/increment/applicant/${jid}`)
            // .then((res)=>{
            //         console.log(res)
            // })
            // .catch((err)=>{
            //         console.log(err)
            // })
          })
          .catch((err) => {
            console.log(err)
          })

      })
      .catch((error) => {
        console.log(error)
      })

  }

  const isValidFileType = (file) => {
    const allowedTypes = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/pdf"];
    return allowedTypes.includes(file.type);
  };

  return (
    <>
      <div className="bg-[#f0f4fc] min-h-screen">
        {
          loader &&
          <div className="">
            <div className="fixed bg-white border shadow-xl md:w-[20%]  p-4 z-40 rounded-xl left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="p-3 rounded-xl text-center  flex flex-col space-y-4">
                <div className="flex flex-col items-center  justify-center">
                  <TailSpin color="black" height="50" width="50"></TailSpin>
                </div>




              </div>
            </div>
          </div>
        }
        {
          popup &&
          <div className="-translate-y-1/2 text-center z-20 bg-white left-1/2 top-1/2  fixed   rounded-xl shadow-2xl border -translate-x-1/2">
            {
              <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <p className="text-lg font-semibold text-center">
                  Do you want to add more candidates?
                </p>
                <div className="flex justify-center gap-4 mt-4">
                  <button
                    onClick={() => {
                      setPopup(false)
                      window.location.reload()
                    }}
                    className="bg-blue-500 text-white px-5 py-2 rounded-lg"
                  >
                    Continue
                  </button>
                  <button
                    onClick={() => {
                      setPopup(false)
                      window.history.back()
                    }}
                    className="border border-blue-500 text-blue-500 px-5 py-2 rounded-lg"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            }
          </div>
        }
        <div className={popup || loader ? "px-10 blur pt-5" : "px-10 pt-5"}>
          <p className="text-2xl font-semibold">New applicant</p>
          <div className="mt-6 bg-white rounded-xl ">
            <div className="flex items-center justify-start bg-[#F1F4FB] rounded-t-xl">
              <button onClick={() => { setTab(0) }} className={tab == 0 ? "px-5 py-3 bg-white rounded-t-xl font-semibold" : "rounded-t-xl px-5 py-3"}>Basic details</button>
              {/* <button onClick={()=>{setTab(1)}} className={tab==1?"px-5 py-3 bg-white rounded-t-xl font-semibold":"rounded-t-xl px-5 py-3"}>Experience details</button>
                    <button onClick={()=>{setTab(2)}} className={tab==2?"px-5 py-3 bg-white rounded-t-xl font-semibold":"rounded-t-xl px-5 py-3"}>Educational details</button>
                    <button onClick={()=>{setTab(3)}} className={tab==3?"px-5 py-3 bg-white rounded-t-xl font-semibold":"rounded-t-xl px-5 py-3"} >Attachments</button> */}
            </div>
            {tab == 0 && (
              <div>
                <div className="p-5  rounded-xl ">
                  <div className="md:flex my-5  md:space-x-3 items-end w-full">
                    <div>
                      <p className="font-semibold">Resume</p>
                      <input
                        type="file"
                        accept=".pdf, .doc, .docx, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        onChange={(e) => {
                          setResume(e.target.files[0]);
                        }}
                        className=""
                      ></input>
                    </div>
                    {/* <button onClick={()=>{
                        if(resume!=null){
                            if (isValidFileType(resume)) {
                                summary();
                            } else {
                                alert("Please upload the resume in PDF or DOC format.");
                            }
                        }
                        else{
                            setEmptyRes(true)
                        }
                        }} className="bg-[#0DCD94] text-white rounded-xl mt-5 md:mt-0 py-1 px-5">
                        {
                            buttonLoader?
                            <TailSpin
                            height="20"
                            width="20"
                            className="text-white"
                            color='#FFFFFF'
                            ></TailSpin>
                            :
                            "Upload"
                        }
                     </button> */}
                  </div>
                  {emptyRes && (
                    <p className="text-red-500">Please upload a resume</p>
                  )}
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>

                <div>
                  <div className="p-5  rounded-xl ">
                    <div className="flex flex-col space-y-4">
                      {/* Row 1: Full Name & WhatsApp Number */}
                      <div className="flex flex-col md:flex-row md:space-x-3 w-full">
                        {/* Full Name */}
                        <div className="md:w-1/2 w-full">
                          <p className="font-semibold">
                            Full name <span className="text-red-500">*</span>
                          </p>
                          <input
                            style={{ textTransform: "capitalize" }}
                            onChange={(e) => setFname(e.target.value)}
                            value={fname}
                            className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${fnameError && fname.length === 0 ? "border-red-500" : ""
                              }`}
                            type="text"
                          />
                          {fnameError && fname.length === 0 && (
                            <p className="text-sm text-red-500 mt-1">Name is mandatory</p>
                          )}
                        </div>

                        {/* WhatsApp Number */}
                        <div className="md:w-1/2 w-full mt-4 md:mt-0">
                          <p className="font-semibold">
                            WhatsApp No. <span className="text-red-500">*</span>
                          </p>

                          <div className="flex space-x-3 mt-2">
                            <select
                              value={countryCode}
                              className="outline-none border px-2 py-2 rounded-lg bg-gray-50 cursor-not-allowed"
                              disabled
                            >
                              <option value={countryCode}>{countryCode}</option>
                            </select>

                            <input
                              value={pnum}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Allow only digits
                                if (/^\d*$/.test(val)) {
                                  setPnum(val);
                                }
                              }}
                              className={`w-full outline-none border px-3 py-2 rounded-lg ${(pnumError || hasCountryCode || invalidLength || startsWithZero)
                                ? "border-red-500"
                                : ""
                                }`}
                              type="text"
                              placeholder="Enter phone number"
                            />
                          </div>

                          {/* Validation Messages */}
                          {hasCountryCode && (
                            <p className="text-sm text-red-500 mt-1">
                              The phone number should not contain country code
                            </p>
                          )}
                          {pnumError && pnum.length === 0 && (
                            <p className="text-sm text-red-500 mt-1">Phone number is mandatory</p>
                          )}
                          {invalidLength && (
                            <p className="text-sm text-red-500 mt-1">
                              Enter your 10 digit WhatsApp number
                            </p>
                          )}
                          {startsWithZero && !invalidLength && (
                            <p className="text-sm text-red-500 mt-1">
                              Phone number should not start with 0
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Row 2: Email & Source */}
                      <div className="flex flex-col md:flex-row md:space-x-3 w-full">
                        {/* Email */}
                        <div className="md:w-1/2 w-full">
                          <p className="font-semibold">
                            Email <span className="text-red-500">*</span>
                          </p>
                          <input
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setIsValidEmail(validateEmail(e.target.value));
                            }}
                            className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${isValidEmail || (emailError && email.length === 0)
                              ? ""
                              : "border-red-500"
                              }`}
                            type="text"
                          />
                          {emailError && email.length === 0 && (
                            <p className="text-sm text-red-500 mt-1">Email is mandatory</p>
                          )}
                        </div>

                        {/* Source of Application */}
                        <div className="md:w-1/2 w-full mt-4 md:mt-0">
                          <div className="flex w-full items-center space-x-1 pb-2">
                            <p className="font-semibold">Source of application</p>
                            <span className="text-red-500">*</span>
                          </div>
                          <Select
                            value={options.find((option) => option.value === source)}
                            onChange={(selectedOption) => {
                              setSource(selectedOption.value);
                            }}
                            options={options}
                            className="w-full"
                          />
                        </div>
                      </div>
                    </div>

                    {source === "Recruitment agency" && (
                      <div>
                        <p className="font-semibold">
                          Agency Name <span className="text-red-500">*</span>
                        </p>
                        <input
                          value={extraDetails.agency_name}
                          onChange={(e) =>
                            setExtraDetails({ agency_name: e.target.value })
                          }
                          className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${!extraDetails?.agency_name?.length &&
                            "border-red-500"
                            }`}
                          type="text"
                        />
                      </div>
                    )}

                    {source === "Employees referral" && (
                      <div className="flex flex-col md:flex-row md:space-x-3 w-full">
                        <div className="md:w-1/2 w-full">
                          <p className="font-semibold">
                            Refered By{" "}
                            <span className="text-red-500">*</span>
                          </p>
                          <input
                            value={extraDetails.refferre_name}
                            onChange={(e) =>
                              setExtraDetails({
                                refferre_name: e.target.value,
                                employee_id: extraDetails.employee_id,
                              })
                            }
                            className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${!extraDetails?.refferre_name?.length &&
                              "border-red-500"
                              }`}
                            type="text"
                          />
                        </div>

                        <div className="md:w-1/2 w-full">
                          <p className="font-semibold">
                            Referee ID{" "}
                            <span className="text-red-500">*</span>
                          </p>
                          <input
                            value={extraDetails.employee_id}
                            onChange={(e) =>
                              setExtraDetails({
                                employee_id: e.target.value,
                                refferre_name: extraDetails.refferre_name,
                              })
                            }
                            className={`w-full outline-none border px-3 py-2 rounded-lg mt-1 ${!extraDetails?.employee_id?.length &&
                              "border-red-500"
                              }`}
                            type="text"
                          />
                        </div>
                      </div>
                    )}

                  </div>
                  <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                  <div className="flex  px-4 py-5 items-center justify-end w-full">
                    <button
                      disabled={
                        !(
                          resume &&
                          fname.length > 0 &&
                          email.length > 0 &&
                          pnum.length > 0 &&
                          !invalidLength &&
                          !startsWithZero &&
                          (source === "Recruitment agency" ?
                            extraDetails?.agency_name?.length > 0 :
                            source === "Employees referral" ?
                              (extraDetails?.employee_id?.length > 0 &&
                                extraDetails?.refferre_name?.length > 0) : source.length)
                        )
                      }
                      className={
                        resume &&
                          fname.length > 0 &&
                          email.length > 0 &&
                          pnum.length > 0 &&
                          !invalidLength &&
                          !startsWithZero &&
                          (source === "Recruitment agency" ?
                            extraDetails?.agency_name?.length > 0 :
                            source === "Employees referral" ?
                              (extraDetails?.employee_id?.length > 0 &&
                                extraDetails?.refferre_name?.length > 0) : source.length)
                          ? "px-6 py-2 text-white bg-[#148EFF] rounded-xl"
                          : "px-6 py-2 text-white bg-gray-400 rounded-xl"
                      }
                      onClick={() => {
                        resSave();
                      }}
                    >
                      Add applicant
                    </button>
                  </div>
                </div>
              </div>
            )}
            {
              tab == 1 &&
              <div>
                <div className="p-5  rounded-xl ">
                  <div className="flex flex-col space-y-4">
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold"> Experience (in years) <span className="text-red-500">*</span></p>
                        <select value={experience} onChange={(e) => { setExperience(e.target.value) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text">
                          {
                            [...Array(31)].map((_, i) => i).map(i => <option key={i} value={i}>{i}</option>)
                          }
                          <option value="30+" >30+</option>
                        </select>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">Highest Qualification</p>
                        <select value={highestQualification} onChange={(e) => { setHighestQualification(e.target.value) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text">
                          <option value=""></option>
                          <option value="Post Graduate / Masters">Post Graduate / Masters</option>
                          <option value="Graduate">Graduate</option>
                          <option value="Degree / Diploma">Degree / Diploma</option>
                          <option value="Ph.D. / Doctrate">Ph.D. / Doctrate</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold"> Current Job Title <span className="text-red-500">*</span></p>
                        <input value={job} onChange={(e) => { setJob(e.target.value) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">Current Company <span className="text-red-500">*</span></p>
                        <input value={company} onChange={(e) => { setCompany(e.target.value) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                      </div>
                    </div>
                    <div className="flex w-full space-x-3">
                      <div className="w-1/2">
                        <p className="font-semibold">Current Salary (anually) </p>
                        <input value={currentSalary} onChange={(e) => { inputNum(e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text">

                        </input>
                      </div>
                      <div className="w-1/2">
                        <p className="font-semibold">Expected Salary (anually) </p>
                        <input value={expectedSalary} onChange={(e) => { inputExpectedSalary(e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                      </div>
                    </div>
                    <div>
                      <p className="font-semibold">Skill Set <span className="text-red-500">*</span></p>
                      <textarea value={skill} onChange={(e) => { setSkill(e.target.value) }} rows="3" className="rounded-lg outline-none w-full border py-2 px-2 mt-2"></textarea>
                    </div>
                  </div>
                  <div>
                    <p className="font-semibold">Additional Info </p>
                    <textarea value={addInfo} onChange={(e) => { setAddInfo(e.target.value) }} rows="3" className="rounded-lg outline-none w-full border py-2 px-2 mt-2"></textarea>
                  </div>

                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">

                  <button onClick={() => { setTab(0) }} className="px-10 py-2 bg-white border border-[#148EFF] text-[#148EFF] rounded-xl">Back</button>
                  <button onClick={() => { setTab(2) }} className="px-6 py-2 text-white bg-[#148EFF] rounded-xl">Save & Next</button>
                </div>
              </div>
            }

            {
              tab == 2 &&
              <div>
                <div className="p-5  rounded-xl ">
                  <div>
                    {
                      educationDetails.map((f, i) => {
                        return (
                          <div className="flex flex-col space-y-4">
                            <div className="flex w-full space-x-3">
                              <div className="w-1/2">
                                <p className="font-semibold">Institute Name <span className="text-red-500">*</span></p>
                                <input name='insName' value={educationDetails[i].insName} onChange={(e) => { handleChange(i, e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                              </div>
                              <div className="w-1/2">
                                <p className="font-semibold">Course Name <span className="text-red-500">*</span></p>
                                <input name='courseName' value={educationDetails[i].courseName} onChange={(e) => { handleChange(i, e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                              </div>
                            </div>
                            <div className="flex w-full space-x-3">
                              <div className="w-1/2">
                                <p className="font-semibold">Start Date <span className="text-red-500">*</span></p>
                                <input name='stDate' value={educationDetails[i].stDate} onChange={(e) => { handleChange(i, e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="date"></input>
                              </div>
                              <div className="w-1/2">
                                <p className="font-semibold">End Date <span className="text-red-500">*</span></p>
                                <input name='endDate' min={educationDetails[i].stDate} value={educationDetails[i].endDate} onChange={(e) => { handleChange(i, e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="date"></input>
                              </div>
                            </div>
                            <div className="w-1/2">
                              <p className="font-semibold">Aggregate Score / Percentage<span className="text-red-500">*</span></p>
                              <input name='score' value={educationDetails[i].score} onChange={(e) => { handleChange(i, e) }} className="w-full outline-none border px-2 py-1 rounded-lg mt-2" type="text"></input>
                            </div>
                            <div className="text-left">
                            </div>
                          </div>
                        );
                      })

                    }
                    <button className="outline-none text-[#148EFF] font-semibold" onClick={addNew}>+ Add New</button>
                  </div>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex space-x-6  px-4 py-5 items-center justify-end w-full">

                  <button onClick={() => { setTab(1) }} className="px-10 py-2 bg-white border border-[#148EFF] text-[#148EFF] rounded-xl">Back</button>
                  <button onClick={() => { setTab(3) }} className="px-6 py-2 text-white bg-[#148EFF] rounded-xl">Save & Next</button>
                </div>
              </div>
            }
            {
              tab == 3 &&
              <div className="mb-10">
                <div className="p-5  rounded-xl ">
                  <div className="flex items-center w-full">

                    <div>
                      <p className="font-semibold">Resume</p>
                      <input type="file" onChange={(e) => { setResume(e.target.files[0]) }} className=""></input>
                    </div>
                  </div>
                </div>
                <div className="bg-[#E9EBFA] h-[0.1rem] w-full"></div>
                <div className="flex space-x-6   px-4 py-5 items-center justify-end w-full">

                  <button onClick={() => { setTab(2) }} className="px-10 py-2 bg-white border border-[#148EFF] text-[#148EFF] rounded-xl">Back</button>
                  <button onClick={() => { addNewApplicant() }} className="px-6 py-2 text-white bg-[#0DCD94]   rounded-xl">Save</button>
                  <div className="relative">

                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}


export default NewCandidate


